
import api from "../utils/api";
import { DASHBOARD_BLOCKED_MESSAGE } from "../utils/dashboardAccess";

export const loginUser = async (username, password) => {
  try {
    const response = await api.post("/signin", { username, password }, { timeout: 10000 });
    if (response?.data?.client && response?.data?.token) {
      const client = {
        ...response.data.client,
        tier: response.data.client.tier || "standard",
      };

      if (client.effective_dashboard_access === false) {
        const blockedError = new Error(DASHBOARD_BLOCKED_MESSAGE);
        blockedError.code = "DASHBOARD_BLOCKED";
        throw blockedError;
      }

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(client));
      return client;
    } else {
      console.error("Invalid login response:", response?.data);
      throw new Error("Invalid login response");
    }
  } catch (error) {
    console.error("Login error:", {
      message: error.message,
      code: error.code,
      status: error?.response?.status,
      responseData: error?.response?.data,
      request: error?.request && (error.request.url || error.request),
    });
    throw error;
  }
};


export const getStoredUser = () => {
  try {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return null;
    const parsed = JSON.parse(storedUser);
    return { ...parsed, tier: parsed.tier || "standard" };
  } catch (error) {
    console.error("Failed to parse stored user", error);
    return null;
  }
};

export const isPremiumUser = () => {
  const user = getStoredUser();
  return user?.tier === "premium";
};

export const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  sessionStorage.removeItem("login_location_asked");
};
